import type { ReactNode } from "react";
import { Box, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface FormWrapperProps {
  children: ReactNode;
}

export const FormWrapper = ({ children }: FormWrapperProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const boxWidth = isMobile ? "100%" : isTablet ? "90%" : "39rem";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "1rem",
      }}
    >
      <Paper
        elevation={1}
        sx={{
          width: boxWidth,
          padding: isMobile ? theme.spacing(2) : theme.spacing(3, 10),
          boxSizing: "border-box",
          height: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            height: "100%",
          }}
        >
          <Box sx={{ flex: 1 }}>{children}</Box>
        </Box>
      </Paper>
    </Box>
  );
};
